/**
 * @generated SignedSource<<6caf169a0b5dddf19032dbfa956cdf5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationsSetDocumentKVPMutation$variables = {
  id: number;
  key: string;
  value: string;
};
export type MutationsSetDocumentKVPMutation$data = {
  readonly setDocumentKVP: {
    readonly _id: number;
    readonly value: string;
  };
};
export type MutationsSetDocumentKVPMutation = {
  response: MutationsSetDocumentKVPMutation$data;
  variables: MutationsSetDocumentKVPMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "concreteType": "DocumentKvp",
    "kind": "LinkedField",
    "name": "setDocumentKVP",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MutationsSetDocumentKVPMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MutationsSetDocumentKVPMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "98c0b96df7a77416d632426d18e11d94",
    "id": null,
    "metadata": {},
    "name": "MutationsSetDocumentKVPMutation",
    "operationKind": "mutation",
    "text": "mutation MutationsSetDocumentKVPMutation(\n  $id: Int!\n  $key: String!\n  $value: String!\n) {\n  setDocumentKVP(id: $id, key: $key, value: $value) {\n    _id\n    value\n  }\n}\n"
  }
};
})();

(node as any).hash = "30cc1ce55ec25df433fd091a9c5b5c46";

export default node;
